import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { yearListRequest, pitcherRankingRequest } from '../../modules/game/ranking'
import PitcherRankingTable from '../../components/game/PitcherRankingTable'
import ContentSwitchingTab from '../../components/common/ContentSwitchingTab'

const RegularLeaguePitcherRankingTableContainer = ({ match, year, onChangeYear }) => {

  const pitcherRankingList = useSelector(state => state.wizData.data && state.wizData.data['PITCHER_RANKING_LIST'])
  // const pitcherRankingListError = useSelector(state => state.wizData.error && state.wizData.error['PITCHER_RANKING_LIST'])

  const allPitcherRankingList = useSelector(state => state.wizData.data && state.wizData.data['ALL_PITCHER_RANKING_LIST'])
  // const allPitcherRankingListError = useSelector(state => state.wizData.error && state.wizData.error['ALL_PITCHER_RANKING_LIST'])

  const yearList = useSelector(state => state.wizData.data && state.wizData.data['YEAR_LIST'])

  const dispatch = useDispatch()

  const [sortKey, setSortKey] = useState('ERA')
  const [playerName, setPlayerName] = useState(null)

  if (yearList && year == null) {
    onChangeYear(yearList.gameYearlist[0].gyear)
  }

  useEffect(() => {
    dispatch(yearListRequest({}, 'YEAR_LIST'))
  }, [dispatch])

  useEffect(() => {
    dispatch(pitcherRankingRequest({ 'gameSearch.gyear': year, 'gameSearch.teamCode': 'KT', 'gameSearch.sortKey': sortKey, 'gameSearch.pname': playerName }, 'PITCHER_RANKING_LIST'))
    dispatch(pitcherRankingRequest({ 'gameSearch.gyear': year, 'gameSearch.sortKey': sortKey, 'gameSearch.inFlag': 'Y', 'gameSearch.pname': playerName }, 'ALL_PITCHER_RANKING_LIST'))
  }, [sortKey, playerName, year])

  const secondContentTabs = [
    { type: 'regular_league', title: 'kt wiz 투수' },
    { type: 'latest_game', title: '전체 투수 순위' }
  ]

  const [contentType, setContentType] = useState(secondContentTabs[0].type)

  const onCliekContentTab = type => {
    setContentType(type)
  }

  return (
    <>
      <ContentSwitchingTab className='detail_lnb_wrap' tabs={secondContentTabs} currentContentType={contentType} onClickContentTab={onCliekContentTab} showPlayerSearch={true} onSearchPlayerName={setPlayerName} onSearchYear={onChangeYear} yearList={yearList && yearList.gameYearlist} />
      <PitcherRankingTable pitcherList={pitcherRankingList} allPitcherList={allPitcherRankingList} tab={contentType} onChangeSort={setSortKey} onChangePlayerName={setPlayerName} onChangeYear={onChangeYear} year={year} sortKey={sortKey} yearList={yearList && yearList.gameYearlist} />
    </>
  )
}

export default RegularLeaguePitcherRankingTableContainer
